<template>
  <div class="downloads">
    <h2 class="downloads__heading">
      Downloads
    </h2>

    <ul class="downloads__list">
      <li v-for="(download, index) in downloadOptions"
          :key="index"
          class="downloads__item">
        <download-component
          v-model="download.isChecked"
          :name="download.name"
          :extension="download.extension"
          :size="download.size"
          :url="download.url"
          selectable>
        </download-component>
      </li>
    </ul>

    <button class="downloads__btn btn btn-accent-6"
            :disabled="!downloadOptions.length"
            @click="onDownloadSelected">
      <loading-spinner v-if="isDownloadInProgress"></loading-spinner>
      <span v-else-if="hasDownloadFailed">
        &#10799;
      </span>
      <span v-else-if="hasDownloadCompleted">
        &#10003;
      </span>
      <span v-else>
        {{ downloadSelectedBtnLabel }}
      </span>
    </button>
  </div>
</template>

<script>
import DownloadComponent from "~/Components/Downloads/DownloadContent.vue";
import downloadHelperMixin from "~/Scripts/mixins/downloaderMixin";
import LoadingSpinner from "~/Components/LoadingSpinner.vue";

const isDownloadableItem = ( {
  id, name, extension, size, url
} ) => (
  typeof id === "string"
  && typeof name === "string"
  && typeof extension === "string"
  && typeof size === "string"
  && typeof url === "string"
);

export default {
  components: {
    LoadingSpinner,
    DownloadComponent
  },
  mixins: [downloadHelperMixin],
  props: {
    downloads: {
      type: Array,
      required: true,
      validator ( value ) {
        return value.every( isDownloadableItem );
      }
    },
    downloadSelectedBtnLabel: {
      type: String,
      default: "Download selected files"
    }
  },
  data () {
    return {
      downloadOptions: []
    };
  },
  created () {
    this.downloadOptions = this.downloads.map( download => ( { ...download, isChecked: false } ) );
  },
  methods: {
    onDownloadSelected () {
      const selectedDownloadOptions = this.downloadOptions.filter( download => download.isChecked );

      this.downloadFiles( selectedDownloadOptions ).then( () => {
        this.resetDownloadOptions();
      } );
    },
    resetDownloadOptions () {
      this.downloadOptions.forEach( option => { option.isChecked = false; } );
    }
  }
};
</script>

<style scoped lang="less">
.downloads {
  margin-top: 30px;
  padding: 0 15px 30px 30px;

  @media ( max-width: 991px ) {
    padding: 0;
  }

  &__heading {
    margin-bottom: 15px;

    @media ( max-width: 991px ) {
      margin-bottom: 15px;
    }
  }

  &__list {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  &__btn {
    min-width: 225px;
    margin-bottom: 10px;
  }
}

.loading-spinner {
  color: #fff;

  /deep/ svg {
    font-size: 1em;
  }
}
</style>
